export const Configurations = {
    dev: {
        name: 'Taxio Desarrollo',
        visits: {
            pricePerKm: 3.45,
            predefinedFrom: true
        },
        races: {
            pricePerKm: 3.45,
            predefinedFrom: true
        },
        api: "http://localhost:8080/api",
        // optimizeApi: "http://50.116.37.106:8001",
        optimizeApi: "https://ruteo.taxiopy.cosmesoft.com.py",
        maps: {
            key: 'AIzaSyD1cykxOJ_xBxdApBQrnRASFT6PfQfR7rY',
            startingLocation: {
                lat: -25.301878, 
                lng: -57.5844456,
                zoom: 13
            },
            region: 'Paraguay'
        },
        menu: {
            showDashboard: true,
            showRepartos: true,
            showNuevoReparto: true,
            showPlanificacionMultidia: true,
            showRepartosRealizados: true,
            showVisitas: true,
            showSistema: true,
            showReportes: true
        }
    },
    prodPy: {
        name: 'Taxio Paraguay',
        visits: { pricePerKm: 2000, predefinedFrom: true },
        races: { pricePerKm: 2000, predefinedFrom: true },
        api: "https://taxiopy.cosmesoft.com.py/api",
        // api: "https://api.taxio.dev.cosmesoft.com.py/api",
        // optimizeApi: "http://50.116.37.106:8001",
        optimizeApi: "https://ruteo.taxiopy.cosmesoft.com.py",
        maps: {
            key: 'AIzaSyD1cykxOJ_xBxdApBQrnRASFT6PfQfR7rY',
            startingLocation: { lat: -25.301878, lng: -57.5844456, zoom: 13 }
        },
        region: 'Paraguay',
        menu: {
            showDashboard: false,
            showRepartos: true,
            showNuevoReparto: false,
            showPlanificacionMultidia: true,
            showRepartosRealizados: false,
            showVisitas: false,
            showSistema: true,
            showReportes: false
        }
    },
    taxioMatiz: {
        name: 'Taxio Matiz',
         visits: { pricePerKm: 2000, predefinedFrom: true },
        races: { pricePerKm: 2000, predefinedFrom: true },
        api: "https://api.taxio.matizsae.com.py/api",
        optimizeApi: "http://50.116.37.106:8001",
         maps: {
            key: 'AIzaSyD1cykxOJ_xBxdApBQrnRASFT6PfQfR7rY',
            startingLocation: { lat: -25.301878, lng: -57.5844456, zoom: 13 }
        },
        region: 'Paraguay',
        menu: {
            showDashboard: true,
            showRepartos: true,
            showNuevoReparto: true,
            showPlanificacionMultidia: true,
            showRepartosRealizados: true,
            showVisitas: true,
            showSistema: true,
            showReportes: true
        }
    }
};

export type ConfigData = typeof Configurations.dev;

export const active: string = 'prodPy';


export function getConfig(configName: string): ConfigData {

    if (Configurations[configName]) {
        return Configurations[configName];
    } else {
        const key = Object.keys(Configurations).find(configKey => {
            if (Configurations[configKey].name === configName) {
                return true
            }
            return false;
        })
        if (key) {
            console.log('new config', key);
            return Configurations[key]
        }
    }
    throw new Error(`Configuration with name ${configName} not found`);
}



// WEBPACK FOOTER //
// ./src/config.ts